import $ from 'jquery';

const $footerMobile = $('.footer-mobile');
const hideClass = 'is-hidden';
const $footerBtn = $('.footer-btn');

// Handle footer mobile visibility
export const handleFooterMobileVisibility = (isVisible) =>
	$footerMobile.toggleClass(hideClass, !isVisible);

// Is floating footer menu visible
export const isFloatingFooterMenu = () => {
	return $footerMobile.hasClass(hideClass);
};

// Set default footer link active state
export const setDefaultFloatingFooterLink = () => {
	$footerBtn.removeClass('is-active');
	$('.js-footer-btn-default-open').addClass('is-active');
};

// Toggle footer mobile links
export const toggleFooterMobileLinks = ($this = false) => {
	// If is footer filter then add active also Discount link
	if ($this && $this.hasClass('js-mini-cart-icon')) {
		$footerBtn.removeClass('is-active');
		$('.js-footer-btn-cart').addClass('is-active');

		// eslint-disable-next-line no-useless-return
		return;
	}

	if ($this) {
		if ($this.hasClass('is-active')) {
			setDefaultFloatingFooterLink();
		} else {
			$footerBtn.removeClass('is-active');

			// If is footer filter then add active also Discount link
			if ($this.hasClass('js-footer-btn-filter')) {
				// $( '.js-footer-btn-discount' ).addClass( 'is-active' );
				setDefaultFloatingFooterLink();
			}

			$this.addClass('is-active');
		}
	} else {
		setDefaultFloatingFooterLink();
	}
};
